import { DatePicker } from "@mui/x-date-pickers";
import { IconButton, InputAdornment } from "@mui/material";
import { CalendarDays, Pencil } from "lucide-react";
import { useState } from "react";

interface Props {
  expiration: bigint | null;
  required: boolean;
  error?: string;
  onChange: (expiration: bigint | null) => void;
}

export default ({ expiration, required, error, onChange }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <DatePicker
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      sx={{
        width: "auto",
        "& .MuiOutlinedInput-root": {
          height: "40px",
          minHeight: "40px",
          padding: "0 4px 0 8px",
          borderRadius: "8px",
          cursor: "pointer",
          "& fieldset": { border: "none !important" },
          "&:hover": { backgroundColor: "action.hover" },
        },
        "& .MuiInputBase-input": {
          marginTop: "0 !important",
          padding: "8px 0",
          width: expiration ? "18ch" : "14ch",
          minWidth: 0,
          flex: "0 0 auto",
          color: error ? "error.main" : "text.primary",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: 500,
        },
        "& .MuiInputBase-input::placeholder": {
          color: error ? "error.main" : "text.primary",
          opacity: 1,
        },
        "& .MuiIconButton-root": {
          padding: "6px",
          color: error ? "error.main" : "text.primary",
        },
        "& .MuiInputAdornment-positionStart": {
          marginRight: "6px",
          color: error ? "error.main" : "text.primary",
        },
        "& .MuiInputAdornment-positionEnd": {
          marginLeft: 0,
        },
      }}
      value={expiration ? new Date(Number(expiration) * 1000) : null}
      format="'Expires' MM/dd/yyyy"
      onChange={(date) => {
        onChange(
          date && !Number.isNaN(date.getTime())
            ? BigInt(Math.floor(date.getTime() / 1000))
            : null,
        );
      }}
      slotProps={{
        textField: {
          required,
          error: !!error,
          placeholder: "Set expiration",
          onClick: (event) => {
            if (!(event.target as HTMLElement).closest("button")) {
              setOpen(true);
            }
          },
          inputProps: { "aria-label": "Expiration" },
          InputProps: {
            startAdornment: (
              <InputAdornment position="start">
                <CalendarDays size={18} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Edit expiration"
                  onClick={() => setOpen(true)}
                >
                  <Pencil size={16} />
                </IconButton>
              </InputAdornment>
            ),
          },
        },
        openPickerButton: { sx: { display: "none" } },
      }}
    />
  );
};
